import { render } from "./IntegrationAuth.vue?vue&type=template&id=45a106fc"
import script from "./IntegrationAuth.vue?vue&type=script&lang=js"
export * from "./IntegrationAuth.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__